const vanBangState = {
  inValid: 1,
  imported: 2,
  choDuyet: 3,
  daDuyet: 4,
}
const getVanBangState = (value) => {
  switch (value) {
    case vanBangState.inValid:
      return 'hợp lệ'
    case vanBangState.imported:
      return 'không hợp lệ'
    case vanBangState.choDuyet:
      return 'chờ duyệt'
    case vanBangState.daDuyet:
      return 'đã duyệt'
    default:
      return ''
  }
}

const checkVanBangIsValid = (value) => {
  switch (value) {
    case vanBangState.inValid:
      return false
    case vanBangState.imported:
      return true
    case vanBangState.choDuyet:
      return true
    case vanBangState.daDuyet:
      return true
    default:
      return false
  }
}

export default vanBangState
export { getVanBangState, checkVanBangIsValid }
